import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';

export const purchaseBurgerSuccess = ( id, orderData ) => {
    return {
        type: actionTypes.PURCHASE_BURGER_SUCCESS,
        orderId: id,
        orderData: orderData
    };
};

export const purchaseBurgerFail = ( error ) => {
    return {
        type:  actionTypes.PURCHASE_BURGER_FAIL,
        error: error
    };
};

export const purchaseBurgerStart = () => {
    return {
        type:  actionTypes.PURCHASE_BURGER_START,
    };
}

export const purchaseInit = ( ) => {
    return {
        type: actionTypes.PURCHASE_INIT
    };
};

export const purchaseBurger = (orderData, token) => {
    return dispatch => {

        dispatch(purchaseBurgerStart());

        axios.post('/order.json?auth=' + token, orderData)
            .then((response) => {
                //console.log(response);
                dispatch(purchaseBurgerSuccess(response.data.name, orderData));
            })
            .catch((error) => {
                //console.log(error);
                dispatch(purchaseBurgerFail(error));
            })
    };
};

export const fetchOrdersSuccess = ( orders ) => {
    return {
        type: actionTypes.FETCH_ORDERS_SUCCESS,
        orders: orders
    }
};

export const fetchOrdersFail = ( error ) => {
    return {
        type: actionTypes.FETCH_ORDERS_FAIL,
        error: error
    };
};

export const fetchOrdersStart = () => {
    return {
        type: actionTypes.FETCH_ORDERS_START
    }
};

export const fetchOrders = (token,userId) => {
    return dispatch => {

        dispatch(fetchOrdersStart());
        
        const queryParams = '?auth=' + token +'&orderBy="userId"&equalTo="' + userId + '"';

        axios.get('/order.json' + queryParams)
             .then((res) => {
                const fetchedOrder = [];
                console.log('orders--------------');
                //console.log(res);
                for(let key in res.data) {
                    fetchedOrder.push({
                        id: key,
                        ...res.data[key]
                    })
                };
                dispatch(fetchOrdersSuccess(fetchedOrder));
             })
             .catch((error) =>{
                dispatch(fetchOrdersFail(error))
             })
    }
}